import { MapPin, Clock, ShieldCheck, ArrowRight, Anchor, Factory, Stethoscope, Wrench, Store, Briefcase } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
export default function CorridorPositionStatement() {
  const industries = [{
    name: "בתי חולים",
    icon: Stethoscope
  }, {
    name: "מרכזי שיקום",
    icon: Factory
  }, {
    name: "דיור מוגן",
    icon: Anchor
  }, {
    name: "מרפאות חוץ",
    icon: Wrench
  }, {
    name: "שירותי קהילה",
    icon: Store
  }, {
    name: "ליווי מקצועי",
    icon: Briefcase
  }];
  return <section data-section-id="261156" id="מיקומים-וביתנות-במודיעין" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div className="flex flex-col space-y-8">
            <div className="space-y-4">
              <Badge variant="secondary" className="bg-secondary/20 text-secondary-foreground hover:bg-secondary/30">
                <MapPin className="w-3 h-3 ml-1" />
                מודיעין והסביבה
              </Badge>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground tracking-tight">
                שירותי סיעוד מקצועיים במודיעין
              </h2>
              <p className="text-lg text-muted-foreground max-w-xl">
                מקרבה למרכז הרפואי מאיר ועד לשירות בבתי המטופלים במודיעין, אנו מספקים מענה סיעודי מהיר ומקצועי שמתאים לקצב החיים ולצרכים הייחודיים של תושבי האזור.
              </p>
            </div>

            <div className="flex flex-wrap gap-2">
              {industries.map((industry, i) => {
              const Icon = industry.icon;
              return <div key={i} data-index={i}>
                    <Badge variant="outline" className="bg-card text-card-foreground border-border py-1.5 px-3">
                      <Icon className="w-3.5 h-3.5 ml-1.5 text-primary" />
                      {industry.name}
                    </Badge>
                  </div>;
            })}
            </div>

            <div className="space-y-4 border-r-4 border-primary pr-6 py-2">
              <h3 className="text-xl font-semibold font-default text-foreground">
                התחייבות STG: זמינות היא ערך עליון
              </h3>
              <p className="text-muted-foreground">
                אנחנו מגיעים אליכם כשזה באמת חשוב. אנו מבטיחים הגעה תוך 5 שעות לכל נקודה במודיעין ובציר המרכזי. עבורנו, הקרבה הגיאוגרפית היא כלי להבטחת איכות הטיפול.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:opacity-90">
                <Link to="/ContactPage">
                  דברו איתנו
                  <ArrowRight className="mr-2 w-4 h-4 rotate-180" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-primary text-primary hover:bg-accent">
                <Link to="/ServicesCitiesArticlesPage">
                  לכל השירותים
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <div className="relative rounded-lg overflow-hidden shadow-lg aspect-[4/3]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/modiin_medical_care_center.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/modiin_medical_care_center.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/modiin_medical_care_center.png-wvc-sizes" alt="מרכז רפואי ושירותי סיעוד במודיעין" className="object-cover w-full h-full" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent flex items-end p-6">
                <div className="text-primary-foreground">
                  <p className="font-semibold font-default text-lg flex items-center gap-2">
                    <Clock className="w-5 h-5 text-secondary" />
                    מענה מהיר תוך 5 שעות במודיעין
                  </p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Card className="bg-card border-border shadow-md hover:shadow-lg transition-shadow rounded-lg">
                <CardContent className="p-6 flex flex-col items-start gap-3">
                  <div className="p-2 bg-primary/10 rounded-lg">
                    <MapPin className="w-6 h-6 text-primary" />
                  </div>
                  <h4 className="font-semibold font-default text-foreground">איפה אנחנו פועלים</h4>
                  <p className="text-sm text-muted-foreground mb-2">צפו בפריסת השירות המלאה שלנו באזור מודיעין והמרכז.</p>
                  <Link to="/CitySpecificSEOPagesForNursingCareProviderPage" className="text-sm font-medium text-primary hover:underline mt-auto flex items-center">
                    לרשימת הערים <ArrowRight className="mr-1 w-3 h-3 rotate-180" />
                  </Link>
                </CardContent>
              </Card>

              <Card className="bg-card border-border shadow-md hover:shadow-lg transition-shadow rounded-lg">
                <CardContent className="p-6 flex flex-col items-start gap-3">
                  <div className="p-2 bg-primary/10 rounded-lg">
                    <ShieldCheck className="w-6 h-6 text-primary" />
                  </div>
                  <h4 className="font-semibold font-default text-foreground">למי אנחנו עוזרים</h4>
                  <p className="text-sm text-muted-foreground mb-2">גלו את מגוון פתרונות הסיעוד המותאמים אישית עבורכם.</p>
                  <Link to="/CaregiverServicePagesPage" className="text-sm font-medium text-primary hover:underline mt-auto flex items-center">
                    לסוגי השירותים <ArrowRight className="mr-1 w-3 h-3 rotate-180" />
                  </Link>
                </CardContent>
              </Card>
            </div>
          </div>

        </div>
      </div>
    </section>;
}